import { render, staticRenderFns } from "./HistorialPaymentDetails.vue?vue&type=template&id=68825721"
import script from "./HistorialPaymentDetails.vue?vue&type=script&lang=js"
export * from "./HistorialPaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./HistorialPaymentDetails.vue?vue&type=style&index=0&id=68825721&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports